import script from "./CoreUiChatHistoryMessageTime.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatHistoryMessageTime.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatHistoryMessageTime.vue?vue&type=style&index=0&id=1dfa2257&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dfa2257"]])

export default __exports__